import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=5355e276&scoped=true"
import script from "./EmergencyContact.vue?vue&type=script&lang=js"
export * from "./EmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5355e276",
  null
  
)

export default component.exports